import { AuthAPI } from '@/api/auth/auth.api';
import { clearAccessToken, getAccessToken } from '@/lib/client';
import { useAuthStore } from '@/store/Auth';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

export const Route = createFileRoute('/')({
  component: IndexPage,
});

function IndexPage() {
  const [loggedIn, setLoggedIn] = useState<boolean>(false);
  const navigate = useNavigate();
  const { setAuth } = useAuthStore();

  useEffect(() => {
    const verifyAuth = async () => {
      const token = getAccessToken();
      const refreshToken =
        globalThis.window?.localStorage.getItem('jumbo-refresh') || null;

      if (!token && (!refreshToken || refreshToken.trim() === '')) {
        navigate({ to: '/login' });
        return;
      }

      try {
        const response = await AuthAPI.getAdminDetails.fn();
        const admin = response.data;
        setAuth({
          user: {
            id: admin.id.toString(),
            email: admin.email,
            name: admin.fullName,
            image: admin.profileImgUrl,
            role: admin.role,
          },
          expires: '',
        });

        if (!loggedIn) {
          navigate({ to: '/dashboard' });
          setLoggedIn(true);
        }
      } catch (error: unknown) {
        const err = error as { response?: { status?: number } };
        if (err?.response?.status === 401) {
          clearAccessToken();
          navigate({ to: '/login' });
        } else {
          console.error('Error verifying auth:', error);
          navigate({ to: '/login' });
        }
      }
    };

    verifyAuth();
  }, [loggedIn, navigate, setAuth]);

  return null;
}
